import { gql } from '@edreamsodigeo/frontend-api-client';
import { api as AirlineTrackingInfo } from './airlineTracking';
import { searchItineraryFragment } from './searchItineraryFragment';
import { searchItinerarySectionFragment } from './searchItinerarySectionFragment';

export const TRAIN_SEARCH_UNBUNDLE_ITINERARY_PRICE_SEGMENT_QUERY = gql`
  query trainSearchUnbundleItineraryPriceSegment(
    $searchTrainsRequest: SearchTrainsRequest!
  ) {
    searchTrains(searchTrainsRequest: $searchTrainsRequest) {
      searchId
      searchCode {
        code
        message
      }
      priceTypeDisplayed
      itineraries {
        ...SearchItineraryFragment
      }
      segments {
        id
        segment {
          id
          duration
          carrierId
          sections
          baggageCondition
          transportTypes
          ticketsLeft
        }
      }
      sections {
        id
        section {
          ...SearchItinerarySectionFragment
        }
      }
      externalSelection {
        id
        segmentKeys
      }
      campaignsItineraryLists {
        campaignItineraryIds
        campaignKey
      }
      freeCancellationItineraryIds
      locations {
        id
        location {
          id
          iata
          cityIata
          cityName
          name
          countryName
          locationType
        }
      }
      carriers {
        id
        carrier {
          id
          name
          supportUrl
        }
      }
      insuranceOffers {
        id
        insuranceOffer {
          id
          url
          policy
        }
      }
      carbonFootprints {
        id
        carbonFootprint {
          isEco
          ecoPercentageThanAverage
          totalCo2Kilos
          totalCo2eKilos
        }
      }
      campaignConfigs {
        id
        campaignConfig {
          primeDayConfig {
            isPrimeDayFare
            primeDayFareType
          }
        }
      }
      trackingInfo {
        returningUserDeviceId
        airlinePositionTracking {
          ...AirlineTrackingInfo
        }
        airlineSteeringTracking {
          ...AirlineTrackingInfo
        }
      }
      unbundledMapping {
        bestMeRating
        cheapestFees {
          price {
            amount
            currency
          }
          type
        }
        compatibleInboundSegments {
          inboundSegmentId
          itineraryKey
          fees {
            price {
              amount
              currency
            }
            type
          }
        }
        outboundSegmentId
      }
    }
  }

  ${AirlineTrackingInfo}
  ${searchItineraryFragment}
  ${searchItinerarySectionFragment}
`;
